module.exports = __webpack_public_path__ + "static/media/restoreIconDeleted.c892b91e.svg";